export default __webpack_public_path__ + "static/stairs_b.97bbedca4fda873b6747aaf72b76966b.png";